import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow the benign "ResizeObserver loop completed with undelivered
// notifications" warning (fired by recharts/observer-based components). It is
// harmless but otherwise triggers the React dev-mode error overlay that can
// cover the page and block clicks.
window.addEventListener('error', (e) => {
  if (e?.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

// PWA service worker: register only on Employee Portal, unregister everywhere else
if ('serviceWorker' in navigator) {
  if (window.location.pathname.startsWith('/employee-portal')) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/portal-sw.js').then((reg) => {
        reg.update();
        if (reg.waiting) {
          reg.waiting.postMessage('SKIP_WAITING');
        }
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (newSW) {
            newSW.addEventListener('statechange', () => {
              if (newSW.state === 'activated') {
                window.location.reload();
              }
            });
          }
        });
      }).catch(() => {});
    });
  } else {
    // Unregister any stale service workers on admin/non-portal pages
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
